import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "loading", "pastDelay", "retry"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingModal = _ref => {
  let passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal, Object.assign({
    dialogClassName: "p-y-12",
    width: 700
  }, passThroughProps, {
    children: /*#__PURE__*/_jsx(DialogBody, {
      paddingBlock: "1200",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.baseCard.loading"
        }),
        showLabel: true
      })
    })
  }));
};
export default LoadingModal;